import {createSvgIcon} from './utils'

export default createSvgIcon(
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M5.49256 2.76846H3.49255L3.49256 9.42532L10.1494 9.42532V7.42532L6.91072 7.42532C6.95642 7.37698 7.00294 7.32912 7.05028 7.28178C9.78395 4.54811 14.2161 4.54811 16.9498 7.28178C18.3166 8.64862 19 10.4401 19 12.2315H21C21 9.92823 20.1213 7.62493 18.364 5.86757C14.8493 2.35285 9.15079 2.35285 5.63607 5.86757C5.58756 5.91608 5.53973 5.965 5.49256 6.01433L5.49256 2.76846ZM18.5075 21.2315H20.5075L20.5075 14.5747H13.8506V16.5747H17.0893C17.0436 16.623 16.9971 16.6709 16.9497 16.7182C14.2161 19.4519 9.78392 19.4519 7.05025 16.7182C5.68341 15.3514 5 13.5599 5 11.7685H3C3 14.0718 3.87868 16.3751 5.63604 18.1324C9.15076 21.6471 14.8492 21.6471 18.364 18.1324C18.4125 18.0839 18.4603 18.035 18.5075 17.9857V21.2315Z"
    fill="#21201F"
  />,
  'ArrowRound',
)
